import * as React from 'react';
import { ToolbarConfig, MenuConfig } from '@tencent/workbench';
import { ActionType } from '@editor/src/js/constants/common-action-type';
import TOOLBAR_PLUGIN from '@tencent/docs-design-resources/pc/svg/toolbar_plugin.svg';
import i18n from '@i18next/i18n';
import { wrapIdForBig, wrapIdForCommon } from '@framework/workbench/util/wrap-id-util';
import { TDWOperationType, TDWActionType, TDWModuleType, TDWVer5Type, EventCodeType, TDWFileType } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';

export const config = {
    id: ActionType.INTELLIGENT_TOOL,
    tipMsg: i18n.t('插件'),
    icon: TOOLBAR_PLUGIN,
    twdConfig: {
        opername: TDWOperationType.DOC_ADDON,
        module: TDWModuleType.ADDON_LIST,
        action: TDWActionType.LIST_VIEW,
        ver5: TDWVer5Type.DOC_DETAIL_TOOLBAR,
        eventcode: EventCodeType.DOC_ADDON_ADDON_LIST_LIST_VIEW,
        file_type: TDWFileType.SLIDE,
    },
    content: i18n.t('插件'),

};

export const TOOLBAR_ITEMS: ToolbarConfig[] = [
    {
        name: config.id,
        icon: <img src={config.icon} alt={''} style={{
            width: 20,
            height: 20,
        }}/>,
        tooltip: config.tipMsg,
    },
    {
        name: wrapIdForBig(config.id),
        icon: <img src={config.icon} alt={''}/>,
        text: config.content,
        tooltip: config.tipMsg,
        style: {
        },
    },
    {
        name: wrapIdForCommon(config.id),
        icon: <img src={config.icon} alt={''}/>,
        text: i18n.t('更多插件'),
        tooltip: config.tipMsg,
        style: {
        },
    },
];

export const MENU_CONFIGS: MenuConfig[] = [
    {
        name: config.id,
        content: config.content,
    },
    {
        name: ActionType.EXTERNAL_ADDONS_PANEL_TITLE,
        content: i18n.t<string>('第三方插件'),
        respectOffline: true,
        style: {
            opacity: 'initial',
            color: 'rgba(0,0,0,.4)',
            cursor: 'default',
        },
    },
];
